<template>
  <div class="base-basic">
    <!-- 自定义头部 -->
    <van-nav-bar class="page-title" :title="isEditMode ? '会议编辑' : '会议申请'" left-text="返回" left-arrow
      @click-left="goBack" />

    <!-- 内容区域 -->
    <div class="body-content">
      <!-- 步骤内容容器 -->
      <div class="step-content">
        <!-- 部门和领域选择 (Step 1) -->
        <van-search v-model="searchValue" placeholder="请输入讲者名称" background="#ffffff" @search="onSearch"
          @clear="onSearchClear" class="search-speaker" />

        <div class="department-selector" v-if="currentStep === 1">


          <!-- 新增：平铺展示TitleCard组件 -->
          <div class="section-header">
            <h3 class="section-title">请选择讲题方向</h3>
          </div>
          <div class="title-cards-container">
            <title-card v-for="item in filteredDepartmentItems" :key="item.text" :title="item.text" :value="item"
              :selected="selectedDepartment === item.text" @click="selectDepartmentByTitle" />
          </div>

          <!-- <van-tree-select
            v-model:active-id="activeId"
            v-model:main-active-index="activeIndex"
            :items="filteredDepartmentItems"
            height="400px"
            @change="onDepartmentAreaChange"
            @click-item="onItemClick"
          /> -->
        </div>

        <!-- 领域列表 (Step 2) -->
        <div class="endorsement-areas-section" v-else-if="currentStep === 2">
          <div class="section-header">
            <h3 class="section-title">细分领域</h3>
          </div>
          <div class="title-cards-container">
            <title-card v-for="area in currentEndorsementAreas" :key="area" :title="area" :value="area"
              :selected="selectedArea === area" @click="selectEndorsementArea" />
          </div>
        </div>

        <!-- 专家列表 (Step 3) -->
        <div class="experts-section" v-else-if="currentStep === 3">
          <div class="section-header">
            <h3 class="section-title">选择讲者</h3>
          </div>
          <SpeakerList :speakers="adaptedExperts" :loading="loading" :selected-speaker-id="selectedExpert?.id"
            @speaker-select="selectExpert" />
        </div>

        <!-- 会议信息填写 (Step 4) -->
        <div class="meeting-info-section" v-else-if="currentStep === 4">
          <!-- 日期选择 -->
          <div class="date-section">
            <van-calendar title="日历" :poppable="false" :show-confirm="false" :style="{ height: '420px' }"
              switch-mode='month ' color='#145294' :show-title='false' :formatter="formatter" @select="onDateSelect"
              :min-date="minDate" :max-date="maxDate" />
          </div>

          <!-- 会议起止时间 -->
          <div class="time-section">
            <h4 class="sub-section-title">会议起止时间</h4>
            <p class="section-subtitle">请选择整场会议开始实际与结束时间</p>
            <div class="time-pickers">
              <van-field v-model="startTime" is-link readonly placeholder="选择开始时间"
                @click="showStartTimePicker = true" />
              <span class="time-separator">至</span>
              <van-field v-model="endTime" is-link readonly placeholder="选择结束时间" @click="showEndTimePicker = true" />
            </div>
            <!-- 时间选择器 -->
            <van-popup v-model:show="showStartTimePicker" position="bottom">
              <van-time-picker v-model="currentStartTime" title="选择开始时间" @confirm="onConfirmStartTime"
                @cancel="onCancelStartTime" />
            </van-popup>
            <van-popup v-model:show="showEndTimePicker" position="bottom">
              <van-time-picker v-model="currentEndTime" title="选择结束时间" @confirm="onConfirmEndTime"
                @cancel="onCancelEndTime" />
            </van-popup>
          </div>

          <!-- 会议形式 -->
          <div class="format-section">
            <h4 class="sub-section-title">会议形式</h4>
            <van-field v-model="meetingFormat" is-link readonly placeholder="点击选择会议形式"
              @click="showFormatPicker = true" />
            <!-- 会议形式选择器 -->
            <van-popup v-model:show="showFormatPicker" position="bottom">
              <van-picker v-model="formatIndex" :columns="formatOptions" @confirm="onConfirmFormat"
                @cancel="showFormatPicker = false" />
            </van-popup>
          </div>

          <!-- 会议类型 -->
          <div class="type-section">
            <h4 class="sub-section-title">会议类型</h4>
            <van-field v-model="meetingType" is-link readonly placeholder="点击选择会议类型" @click="showTypePicker = true" />
            <!-- 会议类型选择器 -->
            <van-popup v-model:show="showTypePicker" position="bottom">
              <van-picker v-model="typeIndex" :columns="typeOptions" @confirm="onConfirmType"
                @cancel="showTypePicker = false" />
            </van-popup>
          </div>

          <!-- 讲者类型 -->
          <div class="type-section">
            <h4 class="sub-section-title">讲者类型</h4>
            <van-field v-model="speakerType" is-link readonly placeholder="点击选择讲者类型"
              @click="showSpeakerTypePicker = true" />
            <!-- 讲者类型选择器 -->
            <van-popup v-model:show="showSpeakerTypePicker" position="bottom">
              <van-picker v-model="speakerTypeIndex" :columns="speakerTypeOptions" @confirm="onConfirmSpeakerType"
                @cancel="showSpeakerTypePicker = false" />
            </van-popup>
          </div>
        </div>

        <!-- 会议确认 (Step 5) -->
        <div class="meeting-confirmation-section" v-else-if="currentStep === 5">

          <MeetingInfoCard :meeting-info="meetingApplication" title="请确认会议信息：" :show-notice="true" />

          <!-- 按钮区域 -->
          <div class="confirm-buttons-container">
            <van-button type="default" size="large" @click="goBack">
              返回修改
            </van-button>
            <van-button type="primary" size="large" @click="submitMeetingApplication" :loading="isLoading"
              :loading-text="isEditMode ? '更新中...' : '提交中...'">
              {{ isEditMode ? '更新会议' : '确认提交' }}
            </van-button>
          </div>
        </div>
      </div>

      <!-- 固定的下一步按钮 -->
      <div class="next-button-container" v-if="currentStep !== 5">
        <van-button type="primary" size="large" block @click="handleNextStep" :loading="isLoading" loading-text="处理中..."
          :disabled="!isNextButtonEnabled">
          {{ nextButtonText }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted, onUnmounted, watch } from 'vue';
import { TreeSelect, Button, Loading, showFailToast, showSuccessToast, Search, Icon, Calendar, Field, Popup, TimePicker, Picker, Image, Dialog, showDialog } from 'vant';
import { useRouter, useRoute } from 'vue-router';
import axios from '@/api/axios';
import moment from 'moment';
import SpeakerList from '@/components/SpeakerList.vue';
import MeetingInfoCard from '@/components/MeetingInfoCard.vue';
import TitleCard from '@/components/TitleCard.vue';


const proudctMap = {
  "倍长平": "DPP4i",
  "思美宁": "钙离子通道调节剂",
  "DPP4i": "倍长平",
  "钙离子通道调节剂": "思美宁"
}

export default {
  name: 'MeetingApplication',
  components: {
    'van-tree-select': TreeSelect,
    'van-button': Button,
    'van-loading': Loading,
    'van-search': Search,
    'van-icon': Icon,
    'van-calendar': Calendar,
    'van-field': Field,
    'van-popup': Popup,
    'van-time-picker': TimePicker,
    'van-picker': Picker,
    'van-image': Image,
    SpeakerList,
    MeetingInfoCard,
    TitleCard
  },
  setup() {
    // 获取路由对象
    const router = useRouter();
    const route = useRoute();

    // 判断是否为编辑模式
    const isEditMode = computed(() => route.path.includes('/edit'));
    const meetingId = computed(() => route.params.id);
    console.log('meetingId:', route.params);
    console.log('meetingId:', meetingId.value);

    // 组件挂载状态跟踪
    const isMounted = ref(false);

    // 部门和领域相关数据
    const activeId = ref('');
    const activeIndex = ref(0);
    const departmentItems = ref([]);
    const filteredDepartmentItems = ref([]);
    const selectedDepartment = ref('');
    const selectedArea = ref('');
    const searchValue = ref('');

    // 专家列表相关
    const experts = ref([]);
    const loading = ref(false);
    const selectedExpert = ref(null);
    // 步骤控制变量：编辑模式下直接初始化为4，避免先显示step1再切换的不良体验
    const currentStep = ref(isEditMode.value && meetingId.value ? 4 : 1);

    // 会议信息相关 (从MeetingInfoForm迁移)
    const selectedDate = ref(new Date());
    const formattedDate = ref('');
    const minDate = ref(new Date('2026-01-01')); // 从2026年1月1日开始
    const maxDate = ref(new Date(new Date().setFullYear(new Date().getFullYear() + 1))); // 最大日期为一年后

    // 时间选择相关
    const showStartTimePicker = ref(false);
    const showEndTimePicker = ref(false);
    const startTime = ref('');
    const endTime = ref('');
    const currentStartTime = ref([9, 0]); // 默认开始时间9:00
    const currentEndTime = ref([10, 0]); // 默认结束时间10:00

    // 会议形式相关
    const showFormatPicker = ref(false);
    const meetingFormat = ref('');
    const formatIndex = ref([0]); // 默认选中第一个选项，注意这里是数组
    const formatOptions = ref([
      { text: '线上会议', value: '线上会议' },
      { text: '线下会议', value: '线下会议' }
    ]);

    // 会议类型相关
    const showTypePicker = ref(false);
    const meetingType = ref('');
    const typeIndex = ref([0]); // 默认选中第一个选项，注意这里是数组
    const typeOptions = ref([
      { text: '中央市场部项目', value: '中央市场部项目' },
      { text: '医学部项目', value: '医学部项目' },
      { text: '销售自办会', value: '销售自办会' },
      { text: '策略运营项目', value: '策略运营项目' }
    ]);

    // 讲者类型相关
    const showSpeakerTypePicker = ref(false);
    const speakerType = ref('');
    const speakerTypeIndex = ref([0]); // 默认选中第一个选项，注意这里是数组
    const speakerTypeOptions = ref([
      { text: '病例讲者', value: '病例讲者' },
      { text: '专题讲者', value: '专题讲者' }
    ]);

    // 按钮加载状态
    const isLoading = ref(false);

    // 适配专家数据为SpeakerList组件需要的格式
    const adaptedExperts = computed(() => {

      let result = experts.value;

      // 按讲者名称过滤
      if (searchValue.value) {
        const keyword = searchValue.value.toLowerCase();
        result = result.filter(speaker =>
          speaker.name.toLowerCase().includes(keyword)
        );
      }

      return result.map(expert => ({
        id: expert.id,
        name: expert.name,
        department: expert.standard_department || expert.department,
        position: expert.title,
        hospital: expert.standard_hospital_name,
        meetingCount: expert.remainingMeetingCount,
        endorsement_area: expert.endorsement_area // 保留领域信息，可在组件中显示
      }));
    });

    // 加载部门和领域数据
    const loadDepartmentAreas = async () => {
      loading.value = true;
      try {
        const response = await axios.get('/api/experts/standard-departments-with-areas');
        if (isMounted.value && response.data.success && response.data.data && Array.isArray(response.data.data)) {
          // 转换数据格式以适配 TreeSelect 组件
          departmentItems.value = response.data.data.map((item, index) => {
            console.log('Department item:', item);
            return {
              text: proudctMap[item.standard_department],
              children: item.endorsement_areas && Array.isArray(item.endorsement_areas)
                ? item.endorsement_areas.map((area, areaIndex) => {
                  const areaItem = {
                    text: area,
                    id: `${index}-${areaIndex}`
                  };
                  console.log('Area item:', areaItem);
                  return areaItem;
                })
                : []
            };
          });
          filteredDepartmentItems.value = departmentItems.value;
          console.log('departmentItems:', departmentItems.value);
        } else if (isMounted.value) {
          showFailToast('获取部门领域数据失败');
        }
      } catch (error) {
        console.error('Error fetching department areas:', error);
        if (isMounted.value) {
          showFailToast('获取部门领域数据时发生错误');
        }
      } finally {
        if (isMounted.value) {
          loading.value = false;
        }
      }
    };

    // 监听部门和领域变化
    const onDepartmentAreaChange = (event) => {
      console.log('onDepartmentAreaChange1111111: event:', event);

      // 根据Vant 4.x的TreeSelect文档，change事件返回的是选中的节点对象
      // 但为了兼容可能的参数变化，我们同时支持event和item两种参数格式
      let item = event;
      if (event && event.currentTarget) {
        // 可能是原生事件对象，尝试获取选中的id
        item = { id: activeId.value };
      }

      console.log('onDepartmentAreaChange1111111: item:', item);

      // 确保有选择的部门和领域
      if (item && item.id) {
        // 找到对应的部门和领域
        for (const department of departmentItems.value) {
          if (department.children && Array.isArray(department.children)) {
            const area = department.children.find(child => child.id === item.id);
            if (area) {
              selectedDepartment.value = department.text;
              selectedArea.value = area.text;
              console.log('Selected department:', selectedDepartment.value);
              console.log('Selected area:', selectedArea.value);
              break;
            }
          }
        }
      }
    };

    // 处理TreeSelect的click-item事件
    const onItemClick = (item) => {
      console.log('onItemClick:', item);
    };

    // 监听activeId和activeIndex变化
    watch(activeId, (newVal) => {
      console.log('activeId changed:', newVal);
      // 当activeId变化时，自动调用onDepartmentAreaChange更新部门和领域
      if (newVal) {
        onDepartmentAreaChange({ id: newVal });
      }
    });

    watch(activeIndex, (newVal) => {
      console.log('activeIndex changed:', newVal);
    });

    // 搜索讲者
    const onSearch = () => {
      currentStep.value = 3;
      loadExpertsByDepartmentAndArea(selectedDepartment.value, selectedArea.value, searchValue.value);
    };
    const onSearchClear = () => {
      
    };



    // 根据部门和领域加载专家列表
    const loadExpertsByDepartmentAndArea = async (department, area, speakerName) => {
      // 支持查询所有专家（不提供department和area参数）
      loading.value = true;
      try {
        // 构建查询参数
        const params = {
          page: 1,          // 默认第1页
          limit: 150         // 默认每页50条
        };

        // 添加部门查询条件（如果有）
        if (speakerName) {
          params.keyword = speakerName;
        }

        if (department) {
          params.product = proudctMap[department];
        }

        // 添加领域查询条件（如果有）
        if (area) {
          params.endorsement_area = area;
        }

        console.log('Making API request to /api/experts with params:', params);
        const response = await axios.get('/api/experts', {
          params: params
        });
        console.log('API response:', response);
        if (isMounted.value && response.data.success) {
          // 转换API返回的数据格式以匹配组件需求
          experts.value = (response.data.data || []).map(expert => ({
            id: expert.id,
            name: expert.name,
            standard_department: expert.standard_department,
            department: expert.department, // 保留原字段以兼容模板
            endorsement_area: expert.endorsement_area,
            title: expert.title,
            standard_hospital_name: expert.standard_hospital_name,
            remainingMeetingCount: expert.remaining_meeting_count,
            // 其他需要的字段
          }));
        } else if (isMounted.value) {
          showFailToast('获取专家列表失败');
          experts.value = [];
        }
      } catch (error) {
        console.error('Error fetching experts:', error);
        if (isMounted.value) {
          if (error.response) {
            showFailToast(`获取专家列表失败：${error.response.data.message}`);
          } else if (error.request) {
            showFailToast('网络异常，请检查网络连接');
          } else {
            showFailToast('获取专家列表失败，请稍后重试');
          }
          experts.value = [];
        }
      } finally {
        if (isMounted.value) {
          loading.value = false;
        }
      }
    };

    // 选择专家
    const selectExpert = (expert) => {
      selectedExpert.value = expert;
      // 选择专家后，获取该专家的已预约日期
      fetchReservedDates(expert.id);
    };

    // 日期选择相关函数
    const formatter = (day) => {
      const formattedDate = moment(day.date).format('YYYY-MM-DD');
      let statusText = '';
      let hasStatus = false;

      // 检查当前日期属于哪种状态
      if (reservedDates.value.pending.includes(formattedDate)) {
        statusText = '邀约中';
        hasStatus = true;
      } else if (reservedDates.value.cannot_attend.includes(formattedDate)) {
        statusText = '无法参会';
        hasStatus = true;
      } else if (reservedDates.value.confirmed.includes(formattedDate)) {
        statusText = '待开展';
        hasStatus = true;
      } else if (reservedDates.value.ongoing.includes(formattedDate)) {
        statusText = '进行中';
        hasStatus = true;
      } else if (reservedDates.value.completed.includes(formattedDate)) {
        statusText = '已结束';
        hasStatus = true;
      }

      // 如果有状态，设置底部信息并禁用该日期
      if (hasStatus) {
        day.bottomInfo = statusText;
        day.disable = true; // 禁用已预约日期
      }

      return day;
    };

    // 处理日期选择
    const onDateSelect = (date) => {
      const formattedDateVal = moment(date).format('YYYY-MM-DD');

      // 检查该日期是否已被预约
      let isReserved = false;
      for (const status in reservedDates.value) {
        if (reservedDates.value[status].includes(formattedDateVal)) {
          isReserved = true;
          break;
        }
      }

      if (isReserved) {
        // 如果已被预约，给出提示
        showFailToast('该日期已被预约，请选择其他日期');
        return;
      }

      // 如果未被预约，正常设置日期
      selectedDate.value = date;
      formattedDate.value = formattedDateVal;
    };

    // 时间选择确认函数
    const onConfirmStartTime = ({ selectedValues }) => {
      currentStartTime.value = selectedValues;
      startTime.value = `${selectedValues[0].toString().padStart(2, '0')}:${selectedValues[1].toString().padStart(2, '0')}`;
      showStartTimePicker.value = false;

      // 检查结束时间是否小于等于开始时间，如果是则重置结束时间
      if (currentEndTime.value[0] < currentStartTime.value[0] ||
        (currentEndTime.value[0] === currentStartTime.value[0] && currentEndTime.value[1] <= currentStartTime.value[1])) {
        // 结束时间设置为开始时间加1小时
        let endHour = parseInt(currentStartTime.value[0]) + 1;
        let endMinute = currentStartTime.value[1];

        currentEndTime.value = [endHour, endMinute];
        endTime.value = `${endHour.toString().padStart(2, '0')}:${endMinute.toString().padStart(2, '0')}`;
      }
    };

    const onCancelStartTime = () => {
      showStartTimePicker.value = false;
    };

    const onConfirmEndTime = ({ selectedValues }) => {
      // 验证结束时间是否大于开始时间
      const startHour = currentStartTime.value[0];
      const startMinute = currentStartTime.value[1];
      const endHour = selectedValues[0];
      const endMinute = selectedValues[1];

      if (endHour < startHour || (endHour === startHour && endMinute <= startMinute)) {
        showFailToast('结束时间必须大于开始时间');
        return;
      }

      currentEndTime.value = selectedValues;
      endTime.value = `${selectedValues[0].toString().padStart(2, '0')}:${selectedValues[1].toString().padStart(2, '0')}`;
      showEndTimePicker.value = false;
    };

    const onCancelEndTime = () => {
      showEndTimePicker.value = false;
    };

    // 会议形式和类型确认函数
    const onConfirmFormat = ({ selectedOptions, selectedIndexes }) => {
      meetingFormat.value = selectedOptions[0].text;
      formatIndex.value = selectedIndexes;
      showFormatPicker.value = false;
    };

    const onConfirmType = ({ selectedOptions, selectedIndexes }) => {
      meetingType.value = selectedOptions[0].text;
      typeIndex.value = selectedIndexes;
      showTypePicker.value = false;
    };

    // 讲者类型选择确认
    const onConfirmSpeakerType = ({ selectedOptions, selectedIndexes }) => {
      speakerType.value = selectedOptions[0].text;
      speakerTypeIndex.value = selectedIndexes;
      showSpeakerTypePicker.value = false;
    };

    // 返回上一步
    const goBack = async () => {
      if (currentStep.value > 1) {
        const previousStep = currentStep.value - 1;
        currentStep.value = previousStep;

        // 如果返回到专家选择页面(步骤3)，且专家列表为空，重新获取数据
        if (previousStep === 3 && (!experts.value || experts.value.length === 0)) {
          await loadExpertsByDepartmentAndArea(selectedDepartment.value, selectedArea.value, searchValue.value);
        }
      } else {
        router.back();
      }
    };

    // 提交会议申请或更新
    const submitMeetingApplication = async () => {
      try {
        if (!isMounted.value) return;
        isLoading.value = true;

        // 将会议日期和时间合并为ISO 8601格式
        const meetingDateTime = `${formattedDate.value}T${startTime.value}:00Z`;
        const meetingEndDateTime = `${formattedDate.value}T${endTime.value}:00Z`;

        // 获取当前登录用户ID
        const currentUser = JSON.parse(localStorage.getItem('userInfo'));
        const creatorId = currentUser ? currentUser.id : 1; // 默认值为1

        // 使用新的API请求格式
        const requestData = {
          scheduled_time: meetingDateTime, // 会议开始时间（ISO 8601格式）
          end_time: meetingEndDateTime, // 会议结束时间（ISO 8601格式）
          expertIds: [selectedExpert.value.id], // 专家ID数组
          meeting_type: meetingType.value, // 会议类型
          meeting_format: meetingFormat.value, // 会议形式
          speaker_type: speakerType.value, // 讲者类型
          creator_id: creatorId // 创建者ID
        };

        let response;

        if (isEditMode.value && meetingId.value) {
          // 编辑模式：调用更新接口
          response = await axios.put(`/api/meetings/${meetingId.value}`, requestData, {
            headers: {
              'Content-Type': 'application/json'
            }
          });
        } else {
          // 创建模式：调用创建接口
          response = await axios.post('/api/meetings', requestData, {
            headers: {
              'Content-Type': 'application/json'
            }
          });
        }

        // 处理API响应
        if (isMounted.value && response.data && (response.data.success || response.data.code === 200)) {
          // 提交成功后清空localStorage中的临时数据
          localStorage.removeItem('meetingInfo');

          // 显示符合图片样式的提交成功提示
          showDialog({
            title: '提交成功提示',
            message: '会议申请成功，会议邀约将以短信形式发送受邀讲者对应的专员，等待对方确认！',
            confirmButtonText: '返回首页',
            showCancelButton: false,
            overlay: true,
            confirmButtonColor: '#145294',
            closeOnClickOverlay: false
          }).then(() => {
            // 跳转到首页
            router.push('/my-meetings');
          });
        } else if (isMounted.value) {
          // 显示API返回的错误信息或默认错误信息
          showFailToast('会议申请提交失败：' + (response.data?.message || '未知错误'));
        }
      } catch (error) {
        console.error('会议申请提交失败:', error);

        // 根据错误类型显示不同的提示信息
        if (isMounted.value) {
          if (error.response) {
            // 服务器返回了错误状态码
            if (error.response.status === 401) {
              showFailToast('登录已过期，请重新登录');
              router.push('/');
            } else if (error.response.status === 400) {
              showFailToast(`请求参数错误，请检查填写的信息：${error.response.data.message}`);
            } else {
              showFailToast(`会议申请提交失败：${error.response.data.message}`);
            }
          } else if (error.request) {
            // 请求已发送但没有收到响应
            showFailToast('网络异常，请检查网络连接');
          } else {
            // 请求配置时发生错误
            showFailToast('会议申请提交失败，请稍后重试');
          }
        }
      } finally {
        // 无论请求成功或失败，都结束加载状态
        if (isMounted.value) {
          isLoading.value = false;
        }
      }
    };

    // 返回部门选择页面
    const backToDepartmentSelect = () => {
      currentStep.value = 1;
      selectedExpert.value = null;
    };

    // 返回领域选择页面
    const backToAreaSelect = () => {
      currentStep.value = 2;
      selectedExpert.value = null;
    };

    // 返回专家选择页面
    const backToExpertSelect = async () => {
      currentStep.value = 3;
      // 如果当前专家列表没有数据，就重新获取
      if (!experts.value || experts.value.length === 0) {
        await loadExpertsByDepartmentAndArea(selectedDepartment.value, selectedArea.value, searchValue.value);
      }
    };

    // 已预约会议日期列表，按状态分类
    const reservedDates = ref({
      pending: [],
      cannot_attend: [],
      confirmed: [],
      ongoing: [],
      completed: []
    });

    // 查询已预约会议日期
    const fetchReservedDates = async (expertId) => {
      try {
        const response = await axios.get('/api/meetings/dates', {
          params: {
            expertId: expertId
          }
        });

        if (isMounted.value && response.data.success) {
          // 初始化按状态分类的日期对象
          const datesByStatus = {
            pending: [],
            cannot_attend: [],
            confirmed: [],
            ongoing: [],
            completed: []
          };

          // 处理API返回的不同状态的日期数据
          for (const status in response.data.data) {
            if (datesByStatus.hasOwnProperty(status)) {
              const dateArray = response.data.data[status] || [];
              // 将每个日期格式化为YYYY-MM-DD格式
              datesByStatus[status] = dateArray.map(dateString => {
                try {
                  const date = new Date(dateString);
                  if (isNaN(date.getTime())) return '';

                  const year = date.getFullYear();
                  const month = String(date.getMonth() + 1).padStart(2, '0');
                  const day = String(date.getDate()).padStart(2, '0');

                  return `${year}-${month}-${day}`;
                } catch (e) {
                  console.error('日期格式转换失败:', e);
                  return '';
                }
              }).filter(date => date !== ''); // 过滤掉无效日期
            }
          }

          // 更新已预约日期列表
          reservedDates.value = datesByStatus;
        }
      } catch (error) {
        console.error('查询已预约会议日期失败:', error);
        if (isMounted.value) {
          showFailToast('查询已预约会议日期失败');
        }
      }
    };

    // 当前选择的部门和其endorsement_areas
    const currentDepartmentItem = ref(null);
    const currentEndorsementAreas = ref([]);

    // 下一步按钮文本计算
    const nextButtonText = computed(() => {
      if (currentStep.value === 1) {
        return '查看领域';
      } else if (currentStep.value === 2) {
        return '查看专家';
      } else if (currentStep.value === 4) {
        return isEditMode.value && meetingId.value ? '更新会议' : '创建会议';
      } else {
        return '下一步';
      }
    });


    // 会议确认信息
    const meetingApplication = ref(null);

    // 下一步按钮是否可用
    const isNextButtonEnabled = computed(() => {
      if (currentStep.value === 1) {
        return selectedDepartment.value;
      } else if (currentStep.value === 2) {
        return !!selectedArea.value;
      } else if (currentStep.value === 3) {
        return !!selectedExpert.value;
      } else if (currentStep.value === 4) {
        return formattedDate.value && startTime.value && endTime.value && meetingFormat.value && meetingType.value && speakerType.value;
      }
      return false;
    });

    // 按钮加载状态
    // const isLoading = ref(false);

    // 统一处理下一步操作
    const handleNextStep = async () => {
      try {
        isLoading.value = true;

        if (currentStep.value === 1) {
          // 步骤1：查看领域
          // 这里不需要加载数据，直接跳转到领域选择页面
          // 查找当前选择的部门对应的endorsement_areas
          const departmentItem = departmentItems.value.find(item => item.text === selectedDepartment.value);
          if (departmentItem) {
            currentDepartmentItem.value = departmentItem;
            currentEndorsementAreas.value = departmentItem.children.map(child => child.text);
          }
          currentStep.value = 2;
        } else if (currentStep.value === 2) {
          // 步骤2：查看专家
          await loadExpertsByDepartmentAndArea(selectedDepartment.value, selectedArea.value, searchValue.value);
          currentStep.value = 3;
        } else if (currentStep.value === 3) {
          // 步骤3：进入会议信息填写
          // 选择专家后，查询该专家的已有会议日期
          await fetchReservedDates(selectedExpert.value.id);
          currentStep.value = 4;
        } else if (currentStep.value === 4) {
          // 步骤4：进入会议确认
          // 构建完整的会议申请数据
          meetingApplication.value = {
            selectedDepartment: selectedDepartment.value,
            selectedArea: selectedArea.value,
            selectedExpert: selectedExpert.value,
            meetingDate: formattedDate.value,
            startTime: startTime.value,
            endTime: endTime.value,
            meetingFormat: meetingFormat.value,
            meetingType: meetingType.value,
            speakerType: speakerType.value
          };

          // 模拟网络延迟，提升用户体验
          await new Promise(resolve => setTimeout(resolve, 300));

          // 切换到确认步骤
          currentStep.value = 5;
        }
      } catch (error) {
        showFailToast('操作失败，请稍后重试');
        console.error('操作失败:', error);
      } finally {
        isLoading.value = false;
      }
    };


    // 根据会议ID获取会议信息
    const getMeetingInfo = async (id) => {
      try {
        const response = await axios.get(`/api/meetings/${id}`);
        if (isMounted.value && response.data.success) {
          const meeting = response.data.data;

          // 解析会议时间 - 使用UTC时区保持与API响应一致
          const meetingDate = moment.utc(meeting.scheduled_time).format('YYYY-MM-DD');
          const startTimeStr = moment.utc(meeting.scheduled_time).format('HH:mm');
          const endTimeStr = moment.utc(meeting.end_time).format('HH:mm');

          // 设置专家信息
          selectedExpert.value = meeting.experts[0];

          // 设置会议信息
          formattedDate.value = meetingDate;
          startTime.value = startTimeStr;
          endTime.value = endTimeStr;

          // 设置时间选择器
          const [startHour, startMinute] = startTimeStr.split(':').map(Number);
          const [endHour, endMinute] = endTimeStr.split(':').map(Number);
          currentStartTime.value = [startHour, startMinute];
          currentEndTime.value = [endHour, endMinute];

          // 设置会议形式、类型和讲者类型
          meetingFormat.value = meeting.meeting_format;
          meetingType.value = meeting.meeting_type;
          speakerType.value = meeting.speaker_type;

          // 查找对应的索引
          const formatOptionIndex = formatOptions.value.findIndex(option => option.text === meeting.meeting_format);
          if (formatOptionIndex !== -1) {
            formatIndex.value = [formatOptionIndex];
          }

          const typeOptionIndex = typeOptions.value.findIndex(option => option.text === meeting.meeting_type);
          if (typeOptionIndex !== -1) {
            typeIndex.value = [typeOptionIndex];
          }

          // 讲者类型回显
          const speakerTypeOptionIndex = speakerTypeOptions.value.findIndex(option => option.text === meeting.speaker_type);
          if (speakerTypeOptionIndex !== -1) {
            speakerTypeIndex.value = [speakerTypeOptionIndex];
          }

          // 直接跳转到步骤4（会议信息填写）
          currentStep.value = 4;
        } else if (isMounted.value) {
          showFailToast('获取会议信息失败');
          router.back();
        }
      } catch (error) {
        console.error('获取会议信息失败:', error);
        if (isMounted.value) {
          showFailToast('获取会议信息失败');
          router.back();
        }
      }
    };

    // 组件挂载时初始化数据
    // 初始化日期时间
    const initDateTime = () => {
      // 初始化日期格式
      formattedDate.value = moment(selectedDate.value).format('YYYY-MM-DD');
      // 初始化时间
      startTime.value = `${currentStartTime.value[0].toString().padStart(2, '0')}:${currentStartTime.value[1].toString().padStart(2, '0')}`;
      endTime.value = `${currentEndTime.value[0].toString().padStart(2, '0')}:${currentEndTime.value[1].toString().padStart(2, '0')}`;
    };

    // 生命周期钩子
    onMounted(async () => {
      isMounted.value = true;
      // 初始化部门和领域数据
      await loadDepartmentAreas();

      // 初始化日期时间
      initDateTime();

      // 如果是编辑模式，加载会议信息
      if (isEditMode.value && meetingId.value) {
        await getMeetingInfo(meetingId.value);

        // 尝试从localStorage中获取部门和领域信息
        const savedDepartment = localStorage.getItem('meetingDepartment');
        const savedArea = localStorage.getItem('meetingArea');
        if (savedDepartment && savedArea) {
          selectedDepartment.value = savedDepartment;
          selectedArea.value = savedArea;
        }
      } else {
        // 非编辑模式，尝试从localStorage中获取已保存的会议申请信息
        const savedMeetingApplication = localStorage.getItem('meetingApplication');
        if (savedMeetingApplication) {
          meetingApplication.value = JSON.parse(savedMeetingApplication);

          // 尝试从localStorage中获取部门和领域信息
          const savedDepartment = localStorage.getItem('meetingDepartment');
          const savedArea = localStorage.getItem('meetingArea');
          if (savedDepartment && savedArea) {
            selectedDepartment.value = savedDepartment;
            selectedArea.value = savedArea;
          }
        }
      }
    });

    // 组件卸载时清理资源
    onUnmounted(() => {
      isMounted.value = false;
    });

    return {
      // 部门和领域相关
      activeId,
      activeIndex,
      departmentItems,
      filteredDepartmentItems,
      selectedDepartment,
      selectedArea,
      searchValue,
      currentDepartmentItem,
      currentEndorsementAreas,
      // 会议确认相关
      meetingApplication,
      submitMeetingApplication,
      // 专家列表相关
      experts,
      loading,
      selectedExpert,
      currentStep,
      adaptedExperts,
      // 会议信息相关
      selectedDate,
      formattedDate,
      minDate,
      maxDate,
      showStartTimePicker,
      showEndTimePicker,
      startTime,
      endTime,
      currentStartTime,
      currentEndTime,
      showFormatPicker,
      meetingFormat,
      formatIndex,
      formatOptions,
      showTypePicker,
      meetingType,
      typeIndex,
      typeOptions,
      showSpeakerTypePicker,
      speakerType,
      speakerTypeIndex,
      speakerTypeOptions,
      isLoading,
      // 计算属性
      nextButtonText,
      isNextButtonEnabled,
      isEditMode,
      meetingId,
      // 函数
      loadDepartmentAreas,
      onDepartmentAreaChange,
      onItemClick,
      loadExpertsByDepartmentAndArea,
      selectExpert,
      handleNextStep,
      goBack,
      backToDepartmentSelect,
      backToAreaSelect,
      backToExpertSelect,
      onSearch,
      onSearchClear,
      formatter,
      onConfirmStartTime,
      onCancelStartTime,
      onConfirmEndTime,
      onCancelEndTime,
      onDateSelect,
      onConfirmFormat,
      onConfirmType,
      onConfirmSpeakerType
    };
  },
  methods: {
    // 通过点击TitleCard选择部门和领域
    selectDepartmentByTitle(department) {
      console.log('selectDepartmentByTitle:', department);
      if (department && department.children && department.children.length > 0) {
        // 选择部门
        this.selectedDepartment = department.text;
        // 保存当前部门项
        this.currentDepartmentItem = department;
        // 获取该部门的endorsement_areas
        this.currentEndorsementAreas = department.children.map(child => child.text);
        // 跳转到领域选择页面
        this.currentStep = 2;
      }
    },

    // 选择领域
    selectEndorsementArea(area) {
      console.log('selectEndorsementArea:', area);
      // 设置选中的领域
      this.selectedArea = area;
      // 找到对应的id
      if (this.currentDepartmentItem) {
        const areaItem = this.currentDepartmentItem.children.find(child => child.text === area);
        if (areaItem) {
          this.activeId = areaItem.id;
        }
      }
    }
  },
 
};
</script>

<style scoped>
.base-basic {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #f5f5f5;
}

/* 平铺卡片容器样式 */
.title-cards-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background-color: #ffffff;
  margin-bottom: 12px;
  border-radius: 8px;
}

/* 调整TitleCard在会议申请页面中的样式 */
.title-cards-container :deep(.title-card) {
  width: 100%;
}

/* 确保搜索框和TreeSelect之间的间距 */
.department-selector {
  display: flex;
  flex-direction: column;
  gap: 12px;
}



.custom-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  background-color: #fff;
  display: flex;
  align-items: center;
  padding: 0 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 999;
}

.back-icon {
  font-size: 20px;
  color: #145294;
  cursor: pointer;
}

/* 会议确认部分样式 */
.meeting-confirmation-section {
  padding: 16px;
}

.confirmation-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid #e8e8e8;
}

.confirm-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.confirm-info-item {
  display: flex;
  margin-bottom: 16px;
  line-height: 1.5;
}

.confirm-info-item:last-child {
  margin-bottom: 24px;
}

.info-label {
  font-size: 15px;
  color: #333;
  margin-right: 10px;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.info-value {
  font-size: 15px;
  color: #333;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.confirm-notice {
  font-size: 14px;
  color: #ff0000;
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #f0f0f0;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

/* 按钮区域样式 */
.confirm-buttons-container {
  padding: 0 16px;
  margin-bottom: 20px;
  display: flex;
  gap: 12px;
}

.confirm-buttons-container .van-button {
  flex: 1;
  height: 44px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.confirm-buttons-container .van-button--default {
  border-color: #dcdfe6;
  background-color: #f5f7fa;
  color: #606266;
}

.confirm-buttons-container .van-button--primary {
  background-color: #145294;
  border-color: #145294;
  color: #fff;
}

.header-title {
  margin: 0;
  font-size: 18px;
  color: #333;
  font-weight: 600;
  margin-left: 16px;
}

.header-title {
  margin: 0;
  font-size: 18px;
  color: #333;
  font-weight: 600;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.experts-section {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
}

.experts-section .SpeakerList {
  flex: 1;
  overflow-y: auto;
}

.next-button-container {
  padding: 16px 0;
  margin-top: auto;
}

.next-button-container .van-button {
  border-radius: 8px;
  background-color: #145294;
}

.section-header {
  padding: 0 16px;
}

.section-title {
  margin: 0 0 16px;
  font-size: 16px;
  color: #333;
  font-weight: 500;
}

/* 平铺卡片容器样式 */
.title-cards-container {
  padding: 0 16px 16px;
}

/* 确保所有section布局统一 */
.department-selector,
.endorsement-areas-section,
.experts-section,
.meeting-info-section {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: 16px;
}

.department-selector {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  height: 100%;
}

.department-selector .van-search {
  margin-bottom: 16px;
}

.department-selector .van-tree-select {
  flex: 1;
  height: auto !important;
  overflow-y: auto;
}

/* 步骤内容容器 */
.step-content {
  flex: 1;
  overflow-y: auto;
  border-radius: 8px;
}

/* 会议信息部分样式 */
.meeting-info-section .date-section,
.meeting-info-section .time-section,
.meeting-info-section .format-section,
.meeting-info-section .type-section {
  padding: 0 16px;
  margin-bottom: 24px;
}

.meeting-info-section .sub-section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
}

.meeting-info-section .section-subtitle {
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
}

.meeting-info-section .time-pickers {
  display: flex;
  align-items: center;
  gap: 12px;
}

.meeting-info-section .time-pickers .van-field {
  flex: 1;
}

.meeting-info-section .time-separator {
  color: #999;
}

/* 固定的下一步按钮容器 */
.next-button-container {
  padding: 16px 0;
  margin-top: auto;
  position: sticky;
  bottom: 0;
  z-index: 10;
}

.next-button-container .van-button {
  border-radius: 8px;
  background-color: #145294;
}

/* 适配底部导航栏 */
.body-content {
  display: flex;
  flex-direction: column;
  /* padding:  ; */
  min-height: calc(100vh - 90px);
  /* 减去头部和底部导航栏高度 */
  flex: 1;
  padding: 10px;
  padding-bottom: 40px;
  /* 为底部导航栏预留空间 */
  overflow-y: hidden;
  /* 不显示滚动条 */
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.search-speaker {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: 8px;
}
</style>